import { SVGProps } from "react";

export function BoxErrorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="18" fill="none" {...props}>
      <path
        stroke="#FF4D4F"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.446 8.175V6.328a2.484 2.484 0 0 0-1.274-2.175L9.208 1.397a2.483 2.483 0 0 0-2.415 0L1.828 4.152A2.483 2.483 0 0 0 .554 6.328v5.345a2.483 2.483 0 0 0 1.274 2.175l4.965 2.756a2.483 2.483 0 0 0 2.415 0l2.101-1.167M14.942 4.83 8 9m0 0L1.06 4.83M8 9v7.908"
      />
      <path
        stroke="#FF4D4F"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="m17.113 11.29-3.334 3.326m0-3.32 3.334 3.326"
      />
    </svg>
  );
}
